import React from 'react'
import styled from 'styled-components'
import {
  ButtonGroup,
  Button,
  Row,
  Label,
  Col,
} from 'reactstrap'
import shortid from 'shortid'
import get from 'lodash/get'
import find from 'lodash/find'
import moment from '../../../../lib/moment.js'
import { statusColor } from '../../helpers/color'
import * as CONSTANTS from '../../constants'
import { FONTS } from '../../../../constants'

export default class RemarkRow extends React.Component {
  state={ hide: false }

  hideInfo = (e) => {
    this.setState({ hide: e })
  }

  render() {
    const users = get(this.props, 'timesheets.users', [])
    const timesheetStatus = get(this.props, 'myTimesheet.timesheetSubmitRequest.status')
    let approve_status = get(this.props, 'myTimesheet.timesheetSubmitRequest.approve_status', [])
    const is_cancel = get(this.props, 'myTimesheet.timesheetSubmitRequest.is_cancel')
    if (is_cancel) {
      const remark_reject_by_hr = get(this.props, 'myTimesheet.timesheetSubmitRequest.remark_reject_by_hr')
      const canceled_by = get(this.props, 'myTimesheet.timesheetSubmitRequest.canceled_by')
      const cancelled_at = get(this.props, 'myTimesheet.timesheetSubmitRequest.cancelled_at')
      approve_status = [...approve_status,
        {
          status: 'REJECTED BY HR',
          remark: remark_reject_by_hr,
          approver_id: canceled_by,
          submitted: cancelled_at,
          is_cancel,
        }]
    }

    return (
      <RemarkTab>
        <Wrapper>
          <TextLabel>Remarks</TextLabel>
          <ButtonGroup>
            <Btn
              onClick={ () => this.hideInfo(true) }
              showhide={ this.state.hide ? 'true' : 'false' }
            >
              Hide
            </Btn>
            <Btn
              onClick={ () => this.hideInfo(false) }
              showhide={ !this.state.hide ? 'true' : 'false' }
            >
              Show
            </Btn>
          </ButtonGroup>
        </Wrapper>
        {
          approve_status.map((status) => {
            const approver = find(users, { _id: status.approver_id })
            return (
              <RemarkBox
                key={ shortid() }
                style={ { display: this.state.hide ? 'none' : 'flex' } }
              >
                <RemarkContent>
                  <Col>
                    <Row>
                      <StatusLabel color={ statusColor(status.status) }>
                        <Circle color={ statusColor(status.status) } />
                        {
                          timesheetStatus === CONSTANTS.REJECTED
                          && status.status === CONSTANTS.PENDING ?
                            CONSTANTS.POSTPONE : status.status
                        }
                      </StatusLabel>
                      <InfoLabel>
                        { status.submitted ? moment(status.submitted).format('DD/MM/YYYY') : '-' }
                      </InfoLabel>
                      <NameLabel>
                        { approver ? `${get(approver, 'first_name')} ${get(approver, 'last_name')} (${get(approver, 'nick_name')})` : '-' }
                      </NameLabel>
                    </Row>
                    <Row>
                      <RemarkLabel>
                        { status.remark !== '' ? status.remark : '-' }
                      </RemarkLabel>
                    </Row>
                  </Col>
                </RemarkContent>
              </RemarkBox>
            )
          }
          )
        }
      </RemarkTab>
    )
  }
}

const Wrapper = styled.div`
  background-color: #FFFFFF ;
  height: 40px;
  width: 100%;
  flex-direction: row;
  flex: 1;
  border-top: 1px solid #EEEEEE;
  border-bottom: 1px solid #EEEEEE;
  padding-left: 10px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const RemarkTab = styled.div`
  background-color: #EEEEEE ;
  flex-direction: column;
  flex: 1;
  border-top: 1px solid #CCCCCC;
  border-bottom: 1px solid #EEEEEE;
  display: flex;
  align-items: center;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const RemarkBox = styled.div`
  background-color: #EEEEEE ;
  border-radius: 5px;
  height: 50px;
  width: 100%;
  padding-left: 10px ;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const RemarkContent = styled.div`
  background-color: #FFFFFF ;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  height: 50px;
  width: 70%;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`
const TextLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin-right: 15px;
  margin-bottom: 0px !important;
`
const NameLabel = styled(Label)`
  display: flex;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-bottom: 0px;
  margin-left: 10px;
  color: ${props => { return props.color ? props.color : 'black' }};
`
const InfoLabel = styled(NameLabel)`
  font-family: ${FONTS.GOTHAM};
  width: 8%;
  margin-left: 10px;
`
const StatusLabel = styled(NameLabel)`
  font-family: ${FONTS.GOTHAM};
  width: 12%;
  margin-left: 30px;
`
const RemarkLabel = styled(NameLabel)`
  font-family: ${FONTS.GOTHAM};
  margin-left: 30px;
  width: 100%;
`
const Btn = styled(Button)`
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #AD2624;
  font-family: ${props => {
    return props.showhide === 'true' ? `${FONTS.GOTHAM_MEDIUM}` : `${FONTS.GOTHAM}`
  }};
  background-color: ${props => {
    return props.showhide === 'true' ? '#D44B49' : '#FFFFFF'
  }};
  color: ${props => {
    return props.showhide === 'true' ? '#FFFFFF' : '#AD2624'
  }};
  &:hover {
    background-color: ${props => {
    return props.showhide === 'true' ? '#D44B49' : '#FFFFFF'
  }};
  color: ${props => {
    return props.showhide === 'true' ? '#FFFFFF' : '#AD2624'
  }};
  }
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/remark-row.js